import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Suggestion } from 'src/models/suggestion';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: 'conversion-suggestion',
    templateUrl: './suggestion.component.html',
    styleUrls: ['./suggestion.component.css']
})

export class SuggestionComponent {
    @Input() suggestion: Suggestion;
    @Output() applied = new EventEmitter<void>();

    constructor() { }
}
